import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { store } from './app/store';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import liveInstance from "./liveController/createLiveInstance";
import {JSBridgeApp} from "@realsee/jsbridge-x/lib/app";
import {JSBridgeContext} from "@realsee/jsbridge-x/lib/react"
import {JSBridgeMiniprogram} from "@realsee/jsbridge-x/lib/miniprogram";
import { JSBridgeBrowser } from './utils/browser'
import { isApp, isMiniprogram } from './utils/deviceDetect'

let value
if (isMiniprogram) value = new JSBridgeMiniprogram()
else if (isApp) value = new JSBridgeApp()
else value = new JSBridgeBrowser()

ReactDOM.render(
  <React.StrictMode>
      <JSBridgeContext.Provider value={value}>
          <Provider store={store}>
              <liveInstance.LiveProvider >
                  <App/>
              </liveInstance.LiveProvider>
          </Provider>
      </JSBridgeContext.Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
